export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "en-US",
    "Messages": {
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "${form.variants > 1 ? 'Generuj obrazy' : 'Generuj obraz'}": "${form.variants > 1 ? 'Generate images' : 'Generate image'}",
        "Adres": "Address",
        "AI CORE": "AI CORE",
        "Akcja nie jest obsługiwana.": "Action is not supported.",
        "Akwarela": "Watercolor",
        "Analiza obrazów, rozpoznawanie wzorów wizualnych": "Image analysis, visual pattern recognition",
        "Angielski": "English",
        "Anuluj": "Cancel",
        "Asystenta AI": "AI Assistant",
        "Błąd podczas edytowania tekstu": "Error while editing text",
        "Błąd podczas generowania dynamicznego formularza": "Error while generating dynamic form",
        "Błąd podczas generowania formularza": "Error while generating form",
        "Błąd podczas generowania metadanych obrazu": "Error while generating image metadata",
        "Błąd podczas pobierania obrazu": "Error while downloading image",
        "Błąd podczas wysyłania obrazu": "Error while uploading image",
        "Brak brak identyfikatora obrazu": "Missing image identifier",
        "Brak kontekstu": "No context",
        "Brak kroków": "No steps",
        "Brak narzędzia": "No tool",
        "Brak obrazów do zapisania": "No images to save",
        "Brak tokenu": "Missing token",
        "Brak wymaganych parametrów modelu AI w zapytaniu": "Missing required AI model parameters in request",
        "Chat, wyszukiwanie, generowanie treści, edytor tekstu": "Chat, search, content generation, text editor",
        "Claymation": "Claymation",
        "Co chcesz wygenerować?": "What do you want to generate?",
        "Cyberpunk": "Cyberpunk",
        "Cyfrowe malarstwo": "Digital painting",
        "Dane osobowe": "Personal data",
        "Data": "Date",
        "Dla najlepszych wyników opisz obraz w języku angielskim": "For best results, describe image in English",
        "Dodaj dostawcę": "Add provider",
        "Dodaj model": "Add model",
        "Dodanie checkbox": "Adding checkbox",
        "Dodanie pola adresu": "Adding address field",
        "Dodanie pola danych osobowych": "Adding personal data field",
        "Dodanie pola daty": "Adding date field",
        "Dodanie pola email": "Adding email field",
        "Dodanie pola rich-text": "Adding rich-text field",
        "Dodanie pola tekstowego": "Adding text field",
        "Dodanie pola telefonu": "Adding phone field",
        "Dodanie strony": "Adding page",
        "Domyślny": "Default",
        "Dostawca": "Provider",
        "Dostawca AI": "AI Provider",
        "Dostawca AI '${currentAiModelConfig.aiProviderName}' nie zawiera zdefiniowanego klucza API": "AI Provider '${currentAiModelConfig.aiProviderName}' does not contain defined API key",
        "Dostawca AI '${currentAiModelConfig.aiProviderName}' nie został znaleziony": "AI Provider '${currentAiModelConfig.aiProviderName}' was not found",
        "Dostawca jest wymagany": "Provider is required",
        "Edycja tekstu": "Text edit",
        "Edytor": "Editor",
        "Edytor tekstu": "Text editor",
        "Email": "Email",
        "Embedding": "Embedding",
        "Embedding nie zwrócił prawidłowych danych": "Embedding did not return valid data",
        "Endpoint": "Endpoint",
        "Entuzjastyczny": "Enthusiastic",
        "Etykieta": "Label",
        "Formalny": "Formal",
        "Format obrazu": "Image format",
        "Format wyjściowy": "Output format",
        "Formularz": "Form",
        "Formularz został wygenerowany, ale nie można go zastosować": "Form has been generated, but cannot be applied",
        "Fotografia": "Photography",
        "Francuski": "French",
        "Generator": "Generator",
        "Generator dynamicznych formularzy": "Dynamic form generator",
        "Generator metadanych obrazu": "Image metadata generator",
        "Generator obrazów": "Image generator",
        "Generator obrazów AI": "AI image generator",
        "Generowana odpowiedź": "Generated answer",
        "Generowanie formularza": "Form generation",
        "Generowanie formularza zakończone.": "Form generation completed.",
        "Generowanie i analiza obrazów, grafik": "Image and graphic generation and analysis",
        "Generowanie obrazów zakończone": "Image generation completed",
        "Generowanie treści": "Content generation",
        "Generowanie treści...": "Generating content...",
        "Generowanie zakończone": "Generation completed",
        "Generuj": "Generate",
        "Generuj formularz": "Generate form",
        "Generuj metadane": "Generate metadata",
        "Generuj obraz": "Generate image",
        "Generuj treść": "Generate content",
        "ID użytkownika": "User ID",
        "Informacje o generatorze": "Generator information",
        "Jakość": "Quality",
        "Jakość wyjściowa": "Output quality",
        "Kliknij generuj obrazy, aby je tutaj zobaczyć": "Click generate images to see them here",
        "Klucz API": "API key",
        "Klucz API OpenAI": "OpenAI API key",
        "Kompresja wyjściowa": "Output compression",
        "Konfiguracja AI jest wyłączona": "AI configuration is disabled",
        "Konfiguracja asystenta ai": "AI assistant configuration",
        "Konfiguracja nieprawidłowa": "Invalid configuration",
        "Konfiguracja prawidłowa": "Valid configuration",
        "Kroki wnioskowania": "Inference steps",
        "Label musi mieć co najmniej 3 znaki": "Label must be at least 3 characters",
        "Label nie może być dłuższy niż 100 znaków": "Label cannot exceed 100 characters",
        "Liczba kroków wnioskowania": "Number of inference steps",
        "Liczba obrazów": "Number of images",
        "Liczba wariantów": "Number of variants",
        "Liczba wyników": "Number of results",
        "Low‑poly": "Low‑poly",
        "Medium": "Medium",
        "Megapiksele": "Megapixels",
        "Model AI '${owner}/${name}' nie został znaleziony dla dostawcy '${provider}'": "AI model '${owner}/${name}' was not found for provider '${provider}'",
        "Moderacja": "Moderation",
        "Mowa": "Speech",
        "Mowa (TTS)": "Speech (TTS)",
        "Mroczne fantasy": "Dark fantasy",
        "Nazwa": "Name",
        "Nazwa musi mieć co najmniej 2 znaki": "Name must be at least 2 characters",
        "Nazwa nie może być dłuższa niż 50 znaków": "Name cannot exceed 50 characters",
        "Neutralny": "Neutral",
        "Nie można pobrać listy przewidywań: ": "Cannot download prediction list: ",
        "Nie można pobrać obrazu": "Cannot download image",
        "Nie można pobrać schematu modelu: ": "Cannot download model schema: ",
        "Nie skonfigurowano żadnego dostawcy AI. Dodaj przynajmniej jednego dostawcy, aby móc korzystać z narzędzi AI.": "No AI provider has been configured. Add at least one provider to use AI tools.",
        "Nie udało się uzyskać odpowiedzi z API.": "Failed to get answer from API.",
        "Nie udało się wygenerować formularza": "Failed to generate form",
        "Nie udało się zmienić rozmiaru obrazu": "Failed to resize image",
        "Nie znaleziono schematu modelu": "Model schema was not found",
        "Nie znaleziono szukanej właściwości schematu wejściowego": "Requested input schema property was not found",
        "Nieformalny": "Informal",
        "Niemiecki": "German",
        "Nieobsługiwana konfiguracja modelu: ": "Unsupported model configuration: ",
        "Nieobsługiwane narzędzie: ${body.Tool}": "Unsupported tool: ${body.Tool}",
        "Nieobsługiwany provider: ": "Unsupported provider: ",
        "Nieznany": "Unknown",
        "Nieznany typ modelu AI": "Unknown AI model type",
        "Obraz": "Image",
        "Obraz wejściowy": "Input image",
        "Obraz został pomyślnie opisany": "Image has been described successfully",
        "Obrazy": "Images",
        "Obrazy wejściowe": "Input images",
        "Oczekiwanie na odpowiedź...": "Waiting for answer...",
        "office worker working at a computer": "office worker working at a computer",
        "Olej na płótnie": "Oil on canvas",
        "Opisz formularz": "Describe form",
        "Opisz jakie pola powinny znajdować się w formularzu": "Describe what fields should be in form",
        "Oryginalny tekst": "Original text",
        "Pixar": "Pixar",
        "Pixel art": "Pixel art",
        "Podstawowe": "Basic",
        "Pola obsługiwane przez generator dynamicznych formularzy.": "Fields supported by dynamic form generator.",
        "Polski": "Polish",
        "Popraw merytorycznie": "Improve content",
        "Pośrednie kroki czasowe": "Intermediate time steps",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Prompt": "Prompt",
        "Proporcje obrazu": "Image aspect ratio",
        "Prosty": "Simple",
        "Prowadzenie": "Guidance",
        "Przejdź do konfiguracji, aby włączyć narzędzia": "Go to configuration to enable tools",
        "Render 3D": "3D render",
        "Repozytorium plików": "File repository",
        "Rozbudowany": "Expanded",
        "Rozbuduj tekst": "Expand text",
        "Rysunek tuszem": "Ink drawing",
        "Silnik": "Engine",
        "Siła promptu": "Prompt strength",
        "Skala prowadzenia": "Guidance scale",
        "Specjalizowane": "Specialized",
        "Sprawdź gramatykę": "Check grammar",
        "Status": "Status",
        "Steampunk": "Steampunk",
        "Streszczenie": "Summary",
        "Strona": "Page",
        "Struktura": "Structure",
        "Studio Ghibli": "Studio Ghibli",
        "Styl": "Style",
        "Styl Tekstu": "Text Style",
        "Synteza mowy, konwersja tekstu na głos": "Speech synthesis, text-to-speech conversion",
        "Synthwave": "Synthwave",
        "Szerokość": "Width",
        "Szkic węglem": "Charcoal sketch",
        "Tak/Nie": "Yes/No",
        "Tekst": "Text",
        "Telefon": "Phone",
        "Test konfiguracji przeszedł pomyślnie": "Configuration test passed successfully",
        "Test konfiguracji przeszedł z ostrzeżeniami": "Configuration test passed with warnings",
        "Test konfiguracji zakończył się niepowodzeniem": "Configuration test failed",
        "Test ustawień": "Test settings",
        "Tło": "Background",
        "Tłumaczenie": "Translation",
        "Tolerancja bezpieczeństwa": "Safety tolerance",
        "Tonalność Tekstu": "Text Tone",
        "Trwa generowanie formularza": "Form generation in progress",
        "Trwa generowanie obrazów": "Image generation in progress",
        "Trwa generowanie opisu dla wybranego obrazu": "Generating description for selected image",
        "Trwa generowanie...": "Generating...",
        "Trwa testowanie konfiguracji...": "Configuration testing in progress...",
        "Tryb szybki": "Fast mode",
        "TTS nie zwrócił prawidłowego audio stream": "TTS did not return valid audio stream",
        "Tu pojawią się wygenerowane obrazy": "Generated images will appear here",
        "Tutaj pojawi się wygenerowana treść...": "Generated content will appear here...",
        "Typ": "Type",
        "Typ musi być jedną z dozwolonych wartości": "Type must be one of allowed values",
        "Ulepszanie promptu": "Prompt enhancement",
        "Ustawienia (opcjonalne)": "Settings (optional)",
        "Usuń dostawcę": "Delete provider",
        "Usuń model": "Delete model",
        "Utworzenie formularza": "Creating form",
        "Wektoryzacja tekstu, analiza semantyczna": "Text vectorization, semantic analysis",
        "Wersja": "Version",
        "Wersja API": "API version",
        "Wersja jest wymagana": "Version is required",
        "Wersja nie może być dłuższa niż 20 znaków": "Version cannot exceed 20 characters",
        "Wierność wejścia": "Input fidelity",
        "Wizja": "Vision",
        "Własne polecenie": "Custom command",
        "Właściciel": "Owner",
        "Właściciel musi mieć co najmniej 2 znaki": "Owner must be at least 2 characters",
        "Właściciel nie może być dłuższy niż 50 znaków": "Owner cannot exceed 50 characters",
        "Wpisz modyfikację np. \"zrób krótsze\", \"dodaj więcej przykładów\"...": "Enter modification e.g. \"make it shorter\", \"add more examples\"...",
        "Wpisz polecenie...": "Enter command...",
        "Wpisz prompt i kliknij przycisk wyślij aby wygenerować odpowiedź...": "Enter prompt and click send button to generate answer...",
        "Wprowadź prompt": "Enter prompt",
        "Wstaw": "Insert",
        "wybierz": "select",
        "Wybróbuj możliwości AI": "Try AI capabilities",
        "Wyczyść wszystkich": "Clear all",
        "Wyczyść wszystkie": "Clear all",
        "Wygenerowana odpowiedź": "Generated answer",
        "Wyłącz sprawdzanie bezpieczeństwa": "Disable safety check",
        "Wysokość": "Height",
        "Wystąpił błąd": "An error occurred",
        "Wystąpił błąd podczas inicjalizacji pluginu AI.": "An error occurred while initializing AI plugin.",
        "Wystąpił błąd podczas modyfikowania treści": "An error occurred while modifying content",
        "Wystąpił problem podczas przesyłania obrazu.": "A problem occurred while uploading image.",
        "Zaawansowany": "Advanced",
        "Zamknij": "Close",
        "Zapisywanie obrazów zakończone.": "Saving images completed.",
        "Zapisywanie obrazów...": "Saving images...",
        "Zapisz": "Save",
        "Zapisz wybrane": "Save selected",
        "Zaznacz tekst, aby wykonać operację AI.": "Select text to perform AI operation.",
        "Ziarno": "Seed"
    }
};
